import L from 'leaflet';
import 'leaflet/dist/leaflet.css'; // Import Leaflet core styles

import { UI_IDS } from './config.js';
import { translations, getLangFromURL } from './i18n.js';
import { MapLayers } from './MapLayers.js';
import { MapAPI } from './MapAPI.js';
import { MapUI } from './MapUI.js';
import { MapEvents } from './MapEvents.js';

// Fix missing default marker icon in bundlers (Vite/Webpack)
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.9.4/images/marker-icon-2x.png',
  iconUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.9.4/images/marker-icon.png',
  shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.9.4/images/marker-shadow.png'
});

export class MapComponent {
    constructor(panoInstance) {
        this.pano = panoInstance;
        
        // Language initialization
        this.lang = getLangFromURL('el');
        this.t = translations[this.lang];
        
        this.map = null;
        this.wpMarkers = L.layerGroup();
        this.panoMarkers = L.layerGroup();
        this.activePanoLayer = null;
        this.arcGisLayers = {};
        
        this.layers = new MapLayers(this);
        this.api = new MapAPI(this);
        this.ui = new MapUI(this);
        this.events = new MapEvents(this);
    }

    async init() {
        this.ui.injectHTML();

        // Initialize base Leaflet map (Wait for next tick to ensure container styles are applied)
        setTimeout(() => {
            if (!this.map) {
                this.map = L.map(UI_IDS.mapContainerId).setView([35.305, 25.072], 15); // Default center (e.g., Heraklion Campus)

                // Add a base tile layer (OSM or similar)
                L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
                    attribution: '© OpenStreetMap contributors',
                    maxZoom: 19
                }).addTo(this.map);

                this.wpMarkers.addTo(this.map);
                this.panoMarkers.addTo(this.map);

                // Setup components
                this.layers.setupArcGISLayers();
                this.ui.buildUI();
                this.events.setupPanoEvents();
                
                // Fetch independently
                this.api.fetchWPLocations(this.lang);
                this.api.fetchPanoramas();
            }
        }, 100);
    }

    setLanguage(lang) {
        // Fallback to safe known language if unmapped
        if (!translations[lang]) lang = 'el';
        
        this.lang = lang;
        this.t = translations[lang];
        
        // 1. Update text elements on the UI
        this.ui.updateUITexts();
        
        // 2. Refetch the mapped content from WP REST API natively in the new language
        this.api.fetchWPLocations(this.lang);
        
        // 3. Option to refetch panoramas if their Titles were dynamically translated
        // this.api.fetchPanoramas();
    }
}